/**
 * Created by Ning Jiang on 12/4/2018.
 */

import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IBetWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {ScalableLayer} from "@nolimitcity/slot-game/bin/core/stage/ScalableLayer";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {MathHelper} from "@nolimitcity/slot-game/bin/core/utils/MathHelper";
import {IdleAnimationController} from "@nolimitcity/slot-game/bin/game/idleanimation/IdleAnimationController";
import {TombstoneGameConfig} from "../TombstoneGameConfig";
import {TimelineLite} from "gsap";

export class GeckoIdleAnimation extends IdleAnimationController {

    private _positions:[number, number][] = [[33, 265], [1189, 300]];
    private _rotations:number[] = [0, Math.PI];

    private _betWinsData:IBetWinData[] | null;
    private _gecko:TimelineSprite;

    constructor() {
        super({
            startTime : 2,
            minInterval : 15,
            maxInterval : 25
        });
    }

    protected onGameDataParsed(data:ParsedGameData):void {
        this._betWinsData = data.betWins;
    }

    protected hasWin():boolean {
        return this._betWinsData != null && this._betWinsData.length > 0;
    }

    protected playIdleAnimation():void {
        if(StageManager.orientation === Orientation.PORTRAIT) {
            return;
        }

        if(!this._gecko) {
            this._gecko = new TimelineSprite(GameResources.getTextures("gecko"), 15);
            this._gecko.blendMode = PIXI.BLEND_MODES.MULTIPLY;
            this._gecko.anchor.set(0.5);
            this._gecko.hide();
            const layer:ScalableLayer = StageManager.getLayer(TombstoneGameConfig.instance.LAYERS.FOREGROUND.name);
            layer.addChild(this._gecko);
        }
        const position:[number, number] = this._positions[Math.round(Math.random())];
        this._gecko.position.set(position[0] + this._gecko.width / 2, position[1] + this._gecko.height / 2);
        this._gecko.rotation = this._rotations[Math.round(Math.random())];
        const stopFrame:number = MathHelper.randomIntInRange(5, 15);
        const stoppingTime:number = MathHelper.randomNumberInRange(0.5, 1.5, 2);
        const timeline:TimelineLite = new TimelineLite();
        timeline.add(this._gecko.getAnimationAutoShowHide(true, false, [0, stopFrame]));
        timeline.add(this._gecko.getAnimationAutoShowHide(true, true, [stopFrame]), timeline.totalDuration() + stoppingTime);
    }
}